import apiClient from './index';

export async function downloadExportZip(zipFilename: string): Promise<void> {
  const response = await apiClient.get(
    `/sigcap/api/download-collection-zip/${encodeURIComponent(zipFilename)}/`,
    { responseType: 'blob' },
  );

  const blob = new Blob([response.data], {
    type: response.headers['content-type'] || 'application/zip',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = zipFilename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
